const fspath = require('path');
const {
  appendPath,
  parsePath
} = require('@truqc/content-path');
const {
  evaluateSource
} = require('./evaluateSource');

/**
 * Resolve another form's content via getFormContentBehavior (live → shared cache → store).
 * Do not use editor scratch (get/setCacheValue formCache) for related-form JSON.
 */
const getFormContent = async (uuid, content, parentContentPath, transientContext, nativeFunctions) => {
  if (uuid === content.id) {
    return content;
  }
  const sourceEvaluator = newSource => evaluateSource(newSource, content, parentContentPath, transientContext, nativeFunctions);
  const formContent = await sourceEvaluator({
    type: 'getFormContentBehavior',
    entityName: 'Form',
    uuid
  });
  return formContent || {};
};
const valueForKey = (key, object) => {
  if (key === '?') {
    const [actualKey] = Object.keys(object);
    if (actualKey === undefined) {
      return undefined;
    }
    return object[actualKey];
  }
  if (key === '*') {
    return object;
  }
  return object[key];
};
const traverseFormContent = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const sourceEvaluator = newSource => evaluateSource(newSource, content, parentContentPath, transientContext, nativeFunctions);
  let formContentPath = await sourceEvaluator(source.contentPath);
  if (formContentPath === undefined) {
    return {};
  }
  let formContent = content;
  let formID = await sourceEvaluator(source.formID);
  if (formID === undefined) {
    formContentPath = appendPath(parentContentPath, formContentPath);
  } else {
    formContent = await getFormContent(formID, content, parentContentPath, transientContext, nativeFunctions);
  }
  const contentForValue = async (value, rest) => {
    if (value === undefined) {
      return undefined;
    }
    const {
      _formRef: newFormID
    } = value;
    if (newFormID === undefined || rest.length === 0) {
      return value;
    }
    formID = newFormID;
    formContent = await getFormContent(formID, content, parentContentPath, transientContext, nativeFunctions);
    formContentPath = fspath.join(...rest);
    return formContent;
  };
  let currentContent = formContent;
  let pathComponents = parsePath(formContentPath);
  while (pathComponents.length > 0) {
    const [first, ...rest] = pathComponents;
    const value = valueForKey(first, currentContent);
    if (value === undefined) {
      return {
        formID,
        formContent,
        formContentPath
      };
    }
    // eslint-disable-next-line no-await-in-loop
    currentContent = await contentForValue(value, rest);
    pathComponents = rest;
  }
  return {
    formID,
    formContent,
    formContentPath,
    value: currentContent
  };
};
module.exports = {
  getFormContent,
  valueForKey,
  traverseFormContent
};